/** @type {import('../schema').ProcessDefinition} */
const cobranza = {
  id: "cobranza",
  name: "Cobranza y morosidad",
  category: "finanzas",
  outcome:
    "Recuperar la deuda vencida con una escalación gradual (recordatorio → intimación → derivación legal), calculando mora e intereses.",
  trigger:
    "Pagos vencidos (vencimiento < hoy); el Administrador abre Cobranza. Un plan asistido por IA prioriza a los morosos.",
  actors: ["Sistema", "Bot Habi", "Administrador", "Residente"],
  status: "PARCIAL",
  description:
    "Núcleo (aging, mora Ley 19.604, plan IA, preview de mensaje, derivación legal y registro) operativo. El envío 100% automático depende de tener plantillas WhatsApp aprobadas; si no, se usa fallback wa.me. La carta-documento formal es inferida.",
  lanes: [
    { id: "sys", actor: "Sistema" },
    { id: "bot", actor: "Bot Habi" },
    { id: "admin", actor: "Administrador" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    { id: "s1", laneId: "sys", type: "start", label: "Detecta pagos vencidos (aging)", description: "Agrupa la deuda por unidad y ocupante y la clasifica por antigüedad (0-30 / 31-60 / 61-90 / 91-180 / 180+ días).", evidence: "src/screens/admin/CobranzaAdmin.jsx" },
    { id: "s2", laneId: "sys", type: "task", label: "Calcula mora (Ley 19.604)", description: "Reajuste por UI + 12% anual simple no capitalizable, con período de gracia. Se suma al desglose como intereses/reajuste.", evidence: "src/utils/interestCalculation.js" },
    { id: "s3", laneId: "bot", type: "task", label: "Arma el plan de cobranza por etapas", description: "Asigna una etapa a cada moroso y prioriza el contacto.", evidence: "CobranzaAdmin.jsx:138 (/api/collection-plan)" },
    { id: "s4", laneId: "bot", type: "document", label: "Genera el borrador del mensaje", description: "Produce un borrador (WhatsApp + email) según la etapa, editable por el admin.", evidence: "CobranzaAdmin.jsx:168 (/preview-message)" },
    { id: "s5", laneId: "admin", type: "task", label: "Revisa y edita el mensaje" },
    { id: "s6", laneId: "admin", type: "decision", label: "¿Hay plantilla aprobada y habilitada?" },
    { id: "s7", laneId: "sys", type: "notification", label: "Envío automático vía Meta", description: "Usa la callable sendCollectionMessage (respeta quiet hours, rate limit y fallback a email).", evidence: "src/utils/habiApi.js (sendCollectionMessageCallable)" },
    { id: "s8", laneId: "admin", type: "notification", label: "Fallback wa.me (copia/pega)", description: "Si no hay plantilla o Meta rechaza, se abre wa.me y el admin envía manualmente." },
    { id: "s9", laneId: "sys", type: "task", label: "Registra el envío", description: "Idempotente por edificio + usuario + período + etapa.", evidence: "CobranzaAdmin.jsx:473 (/log-sent)" },
    { id: "s10", laneId: "admin", type: "decision", label: "¿Intención de pago o caso a escalar?" },
    { id: "s11", laneId: "admin", type: "handoff", label: "Deriva a gestor legal", description: "Persiste legal_handoff y notifica.", evidence: "CobranzaAdmin.jsx:359 (/derive-legal)" },
    { id: "s12", laneId: "admin", type: "task", label: "Concilia el pago", description: "Aprueba/rechaza el comprobante o registra un pago manual; al saldar, marca multas incluidas como pagadas." },
    { id: "s13", laneId: "res", type: "end", label: "Deuda saldada o caso derivado" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7", label: "sí" },
    { from: "s6", to: "s8", label: "no" },
    { from: "s7", to: "s9" },
    { from: "s8", to: "s9" },
    { from: "s9", to: "s10" },
    { from: "s10", to: "s11", label: "no pagó / 90+ días" },
    { from: "s10", to: "s12", label: "intención de pago" },
    { from: "s11", to: "s13", label: "vía legal" },
    { from: "s12", to: "s13", label: "saldado" },
  ],
};

export default cobranza;
